import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  opacity: 1,
  transition: 'opacity 0.3s',
  maxWidth: 310,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 430,
}));

export const AutoHeightBox = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});
